import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { Periode } from "@/types";
import SkeletonTable from "@/components/SkeletonTable";
import { getListPeriode } from "@/services/getData";
import { useTahun } from "@/hooks/useTahun";

export interface PeriodeResponse {
  data: Periode[];
}

export default function SettingPeriodePage() {
  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: ["listPeriode", selectedTahun?.label],
    queryFn: () => getListPeriode(selectedTahun?.label),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  );
}
